const arch = [
    {
        color: 'pink',
        rating: 'v1',
        location: 'arch',
        image: 'https://i.imgur.com/VjN6fRJ.jpg',
        id: 1,
    },
    {
        color: 'blue',
        rating: 'v2',
        location: 'arch',
        image: 'https://i.imgur.com/6SeLlj5.jpg',
        id: 2,
    },
    {
        color: 'green',
        rating: 'v4',
        location: 'arch',
        image: 'https://i.imgur.com/ijTaGcW.jpg',
        id: 3,
    },
    {
        color: 'red',
        rating: 'v4',
        location: 'arch',
        image: 'https://i.imgur.com/uor39UV.jpg',
        id: 4,
    },
    {
        color: 'yellow',
        rating: 'v6',
        location: 'arch',
        image: 'https://i.imgur.com/EbdhUPG.jpg',
        id: 5,
    },
    {
        color: 'yellow',
        rating: 'v2',
        location: 'arch',
        image: 'https://i.imgur.com/tIZqEdc.jpg',
        id: 6,
    },
]

const back = [
    {
        color: 'red',
        rating: 'v2',
        location: 'back',
        image: 'https://i.imgur.com/uzwOFU2.jpg',
        id: 7,
    },
    {
        color: 'green',
        rating: 'v0',
        location: 'back',
        image: 'https://i.imgur.com/U0EPMjU.jpg',
        id: 8,
    },
    {
        color: 'pink',
        rating: 'v1',
        location: 'back',
        image: 'https://i.imgur.com/EAJkMYV.jpg',
        id: 9,
    },
    {
        color: 'red',
        rating: 'v1',
        location: 'back',
        image: 'https://i.imgur.com/8pHFcnc.jpg',
        id: 10,
    },
    {
        color: 'yellow',
        rating: 'v4',
        location: 'back',
        image: 'https://i.imgur.com/7ZX0D6E.jpg',
        id: 11,
    },
    {
        color: 'blue',
        rating: 'v6',
        location: 'back',
        image: 'https://i.imgur.com/3NngQ7b.jpg',
        id: 12,
    },
]

const hole = [
    {
        color: 'pink',
        rating: 'v1',
        location: 'hole',
        image: 'https://i.imgur.com/t0r5LIp.jpg',
        id: 13,
    },
    {
        color: 'blue',
        rating: 'v0',
        location: 'hole',
        image: 'https://i.imgur.com/Vs8FMq0.jpg',
        id: 14,
    },
    {
        color: 'green',
        rating: 'v3',
        location: 'hole',
        image: 'https://i.imgur.com/b3Z8THT.jpg',
        id: 15,
    },
    {
        color: 'blue',
        rating: 'v4',
        location: 'hole',
        image: 'https://i.imgur.com/rxdCkcL.jpg',
        id: 16,
    },
    {
        color: 'red',
        rating: 'v7',
        location: 'hole',
        image: 'https://i.imgur.com/FgqAVf4.jpg',
        id: 17,
    },
    {
        color: 'green',
        rating: 'v8',
        location: 'hole',
        image: 'https://i.imgur.com/hcMfCiB.jpg',
        id: 18,
    },
]

const inside = [
    {
        color: 'green',
        rating: 'v0',
        location: 'inside',
        image: 'https://i.imgur.com/KpbHjez.jpg',
        id: 19,
    },
    {
        color: 'blue',
        rating: 'v2',
        location: 'inside',
        image: 'https://i.imgur.com/NliBkSf.jpg',
        id: 20,
    },
    {
        color: 'pink',
        rating: 'v3',
        location: 'inside',
        image: 'https://i.imgur.com/AjN0yzX.jpg',
        id: 21,
    },
    {
        color: 'yellow',
        rating: 'v5',
        location: 'inside',
        image: 'https://i.imgur.com/gQPN8PL.jpg',
        id: 22,
    },
    {
        color: 'red',
        rating: 'v8',
        location: 'inside',
        image: 'https://i.imgur.com/5NAf5zU.jpg',
        id: 23,
    },
    {
        color: 'red',
        rating: 'v5',
        location: 'inside',
        image: 'https://i.imgur.com/ZpB5TNz.jpg',
        id: 24,
    },
]

const slant = [
    {
        color: 'blue',
        rating: 'v3',
        location: 'slant',
        image: 'https://i.imgur.com/OVoFODp.jpg',
        id: 25,
    },
    {
        color: 'blue',
        rating: 'v1',
        location: 'slant',
        image: 'https://i.imgur.com/0mdxT1O.jpg',
        id: 26,
    },
    {
        color: 'pink',
        rating: 'v3',
        location: 'slant',
        image: 'https://i.imgur.com/Kv1F8Aw.jpg',
        id: 27,
    },
    {
        color: 'yellow',
        rating: 'v9',
        location: 'slant',
        image: 'https://i.imgur.com/LXhvG2D.jpg',
        id: 28,
    },
    {
        color: 'red',
        rating: 'v5',
        location: 'slant',
        image: 'https://i.imgur.com/Uqxj6cE.jpg',
        id: 29,
    },
    {
        color: 'pink',
        rating: 'v0',
        location: 'slant',
        image: 'https://i.imgur.com/yVJGaZO.jpg',
        id: 30,
    },
]

const Walls = {
    arch,
    back,
    hole,
    inside,
    slant,
}

export default Walls;